import { render, staticRenderFns } from "./Whitelabels.vue?vue&type=template&id=e6de3f74"
import script from "./Whitelabels.ts?vue&type=script&lang=ts&external"
export * from "./Whitelabels.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports